(function (app, ng) {

    /*
Service: figGlobalModalSubstate
Allow a modal to be opened statefully from anywhere

This service allows you to register a state as a substate of all other* states

Usage: 
app.config(["figGlobalModalSubstateProvider", function(figGlobalModalSubstateProvider) {
    figGlobalModalSubstateProvider.registerComponent({
        url: "/NewTask", 
        component: "newTask", 
        stateSuffix: "NewTask"
        parent: "Home.Dashboard"
    });
}]);
This will create a /NewTask route for all other existing routes/states: /Home/Dashboard/NewTask, /Home/SomethingElse/NewTask etc
parent is a string value that will act as a filter to only attach this substate to any state who's name contains the parent name.

Room for expansion:
- right now when you register a substate, it attaches to all normally registered states
    - might be useful for caller to pass a filter function if they want to only be a substate of some other states
- currently only implemented for modal substates that use components, not templates/controllers
    - should be easy to create a second array of registrations and allow for them, just haven't needed to yet

    */
    app.provider("figGlobalModalSubstate",
        [
            function () {
                var componentStates = [];

                this.registerComponent = registerComponent;

                this.$get = [
                    function () {
                        return {
                            componentStates: componentStates
                        };
                    }
                ];

                //in the form of { stateSuffix: name, component: component, url: url, parent: parent }
                function registerComponent(componentState) {
                    componentStates.push(componentState);
                }
            }
        ]);

    //keep references to these so we can use them in app.run block
    var local$StateProvider, localFigStateProvider;
    app.config(["$stateProvider", "figModalStateProvider", function ($stateProvider, figModalStateProvider) {
        //config blocks run before app.run blocks
        local$StateProvider = $stateProvider;
        localFigStateProvider = figModalStateProvider;
    }]);

    app.run(["figGlobalModalSubstate", "_", function (figGlobalModalSubstate, _) {
        //get a copy of the states defined that won't change as we add more states
        //no need to create Some.State.NewClient.NewPolicy for example
        var states = [];
        ng.forEach(local$StateProvider.stateRegistry.states, function (state) {
            states.push(state);
        });

        //loop through all previously defined states (this will happen after all other app.config blocks, so all normal states will already be defined)
        //and create a child modal state for example
        ng.forEach(figGlobalModalSubstate.componentStates, function (componentState) {
            ng.forEach(states, function (existingState) {
                var newName = existingState.name + "." + componentState.stateSuffix;

                //if the state doesn't have a name, or the state is already registered, skip
                if (!existingState.name || local$StateProvider.stateRegistry.states[newName]) return;
                //if parent is defined and the existing state name does not contain the parent name, skip
                if (componentState.parent && !_.includes(existingState.name, componentState.parent)) return;

                localFigStateProvider.state(newName,
                    {
                        url: componentState.url,
                        component: componentState.component,
                        resolve: componentState.resolve
                    });
            });
        });
    }]);

})(window.app, window.angular); // jshint ignore:line